import React, { useState, useEffect } from "react";
import Table from "../components/Table/Table";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import ApiManager from "../ApiManager/ApiManager";
import SearchBar from "../components/SearchBar/SearchBar";
import NewBillingItem from "./NewBillingItem";
import Modal from "../components/Modal/Modal";
import ViewEntity from "../components/ViewEntity/ViewEntity";
import EditEntity from "../components/EditEntity/EditEntity";
import { useAuth } from "../components/AuthProvider";
import { hasPermission, ShowButton } from "../components/RoleBasedComponents";
import PERMISSIONS from "../permissions";
import { useComponentLoading } from "../utils/useComponentLoading";

function BillingItems() {
  const { userPermissions } = useAuth();
  const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();
  const [currentRowId, setCurrentRowId] = useState(null);
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [billingItem, setBillingItem] = useState([]);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleEdit = () => {
    console.log("Edit clicked for row:");
    setDetails(false);
    setEdit(true);
    setModalOpen(true);
    fetchBillingItem();
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  // if (hasPermission(userPermissions, PERMISSIONS.VENDOR_BILLING_ITEM_UPDATE)) {
  //   buttons.push({ label: "Edit", onClick: () => handleEdit() });
  // }

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('fetchBillingItems', async (onProgress) => {
        onProgress(20, 'Fetching billing items...');
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        const response = await ApiManager.getAllBillingItems(params);
        onProgress(60, 'Processing data...');
        if (!response.ok) throw new Error("Failed to fetch Billing Items");
        const json = await response.json();
        setData(json);
        setHasMorePages(json.length == 12);
        onProgress(100, 'Completed');
      });
    } catch (error) {
      console.error("Error fetching billing items:", error);
      setHasMorePages(false);
    }
  };

  const fetchBillingItem = async () => {
    try {
      await withLoading('fetchBillingItemDetails', async (onProgress) => {
        onProgress(30, 'Fetching billing item details...');
        setCurrentRowId(rowId);
        const query = new URLSearchParams({
          billingItemId: rowId,
        });
        const response = await ApiManager.getBillingItem(query);
        onProgress(70, 'Processing item data...');
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setBillingItem(json);
        onProgress(100, 'Completed');
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    { field: "taxable", headerName: "Taxable" },
    { field: "allow_driver_to_add", headerName: "Allowed driver to add" },
  ];

  const editColumns = [
    { name: "name", label: "Name", type: "text" },
    { name: "description", label: "Description", type: "text" },
    { name: "taxable", label: "Taxable", type: "checkbox" },
    { name: "allow_driver_to_add", label: "Allowed driver to add", type: "checkbox" },
  ];

  const rows = (data || []).map((item) => ({
    id: item.billingItemId,
    name: item.name,
    description: item.description,
    taxable: item.taxable,
    allow_driver_to_add: item.allow_driver_to_add,
  }));

  const handleEditBillingItems = async (formData) => {
    const updatedFormData = {
      ...formData,
    };

    const query = new URLSearchParams({
      billingItemId: currentRowId,
    });
    const response = await ApiManager.updateBillingItem(
      query,
      updatedFormData
    );
    return response;
  };

  return (
    <div>
      <TopNavbar
        title="Billing Items"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          paddingTop: "20px",
        }}
      >
        {/* <SearchBar /> */}
        <ShowButton permission={PERMISSIONS.VENDOR_BILLING_ITEM_CREATE}>
          <NewBillingItem onSuccess={fetchData}/>
        </ShowButton>
      </div>

      <Table
        table_columns={columns}
        rows={rows}
        setRowsId={setRowId}
        // buttons={buttons}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        hasMorePages={hasMorePages}
        isLoading={isLoading('fetchBillingItems')}
        loadingMessage={getMessage('fetchBillingItems')}
        loadingProgress={getProgress('fetchBillingItems')}
      />

      {/* {isModalOpen && isDetails && (
        <div className="details-container">
          <Modal isOpen={true} onClose={handleModalClose}>
            <ViewEntity
              id={rowId}
              fetchFunction={ApiManager.getBillingItem}
              columns={columns}
              entity="billingItemId"
            />
          </Modal>
        </div>
      )} */}
      {isModalOpen && isEdit && (
        <div className="edit-container">
          <Modal isOpen={true} onClose={handleModalClose}>
            <EditEntity
              // id={rowId}
              updateFunction={handleEditBillingItems}
              columns={editColumns}
              title={"Edit Billing Item"}
              prevData={billingItem}
              toggleFunction={toggleModal}
              // onSaveSuccess={() => alert('Entity updated successfully!')}
            />
          </Modal>
        </div>
      )}
    </div>
  );
}

export default BillingItems;
